export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatCOP = (n) =>
  new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  }).format(n);
